(function () {
  'use strict';
  if (window.SwishCBHoopInfo) return;

  var HANDLE = 'goalrilla-cv72-in-ground-basketball-hoop';
  var MODEL = 'https://cdn.shopify.com/3d/models/cf68a9e155ccf16d/Goalrilla_CV72_3D_View_optimized.glb';
  var products = new Map();
  var dialog, content, opener, request, restoreScroll, modelLoader;
  var generation = 0;

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function number(value, decimals) {
    return String(Number(value.toFixed(decimals)));
  }

  function inches(value) {
    var parts = value.trim().split(/\s+/);
    return parts.reduce(function (sum, part) {
      var fraction = part.split('/');
      return sum + (fraction.length === 2 ? Number(fraction[0]) / Number(fraction[1]) : Number(part));
    }, 0);
  }

  // Product copy includes both systems. Derive metric values from the source
  // imperial dimensions, rather than inheriting rounded/inconsistent pairs.
  function regionalText(text, country) {
    var value = text.replace(/\s*\((?=[^)]*\b(?:mm|cm|m|kg)\b)(?:[\d.\s×x–-]|mm|cm|kg|m)+\)/g, '');
    if (country === 'US') return value;
    value = value.replace(/\b(\d+(?:\.\d+)?)\s+to\s+(\d+(?:\.\d+)?)\s+(?:foot|feet|ft)\b/gi, function (_, low, high) {
      return number(Number(low) * 0.3048, 3) + ' to ' + number(Number(high) * 0.3048, 3) + ' m';
    });
    value = value.replace(/\b(\d+(?:\.\d+)?)\s*(?:ft|foot|feet)\b/gi, function (_, feet) {
      return number(Number(feet) * 0.3048, 3) + ' m';
    });
    value = value.replace(/\b(\d+\s+\d+\/\d+|\d+\/\d+|\d+(?:\.\d+)?)\s*(?:["″]|-inch\b|inches\b|inch\b|in\b(?!-))/gi, function (_, size) {
      var cm = inches(size) * 2.54;
      return cm < 2 ? number(cm * 10, 2) + ' mm' : number(cm, 2) + ' cm';
    });
    return value.replace(/\b(\d+(?:\.\d+)?)\s*(?:lbs?\.?|pounds?)\b/gi, function (_, lbs) {
      return number(Number(lbs) * 0.45359237, 2) + ' kg';
    });
  }

  function lockScroll() {
    var body = document.body;
    var y = window.scrollY, x = window.scrollX;
    var keys = ['position', 'top', 'left', 'width', 'overflow', 'paddingRight'];
    var old = keys.map(function (key) { return body.style[key]; });
    var gutter = window.innerWidth - document.documentElement.clientWidth;
    var padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
    body.style.position = 'fixed';
    body.style.top = -y + 'px';
    body.style.left = -x + 'px';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (gutter) body.style.paddingRight = padding + gutter + 'px';
    return function () {
      keys.forEach(function (key, index) { body.style[key] = old[index]; });
      window.scrollTo({ left: x, top: y, behavior: 'instant' });
    };
  }

  function makeDialog() {
    dialog = element('dialog', 'swishcb-hoop-info');
    dialog.setAttribute('aria-labelledby', 'swishcb-hoop-info-title');
    var header = element('div', 'swishcb-hoop-info__header');
    var title = element('h2', '', 'Goalrilla CV72');
    title.id = 'swishcb-hoop-info-title';
    var close = element('button', 'swishcb-hoop-info__close', '×');
    close.type = 'button';
    close.autofocus = true;
    close.setAttribute('aria-label', 'Close hoop information');
    close.addEventListener('click', function () { dialog.close(); });
    header.append(title, close);
    content = element('div', 'swishcb-hoop-info__content');
    dialog.append(header, content);
    document.body.append(dialog);
    var backdropDown = false;
    function outside(event) {
      var box = dialog.getBoundingClientRect();
      return event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
    }
    dialog.addEventListener('pointerdown', function (event) { backdropDown = outside(event); });
    dialog.addEventListener('click', function (event) {
      if (backdropDown && outside(event)) dialog.close();
      backdropDown = false;
    });
    dialog.addEventListener('close', function () {
      generation += 1;
      if (request) request.abort();
      content.querySelectorAll('video').forEach(function (video) { video.pause(); });
      content.replaceChildren(); // Also stops iframe video and releases the 3D viewer.
      if (restoreScroll) restoreScroll();
      restoreScroll = null;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
  }

  function loadModelViewer() {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (modelLoader) return modelLoader;
    modelLoader = new Promise(function (resolve, reject) {
      var script = element('script');
      script.type = 'module';
      script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
      script.onload = function () {
        if (customElements.get('model-viewer')) resolve();
        else { script.remove(); modelLoader = null; reject(new Error('3D viewer unavailable')); }
      };
      script.onerror = function () { script.remove(); modelLoader = null; reject(new Error('3D viewer unavailable')); };
      document.head.append(script);
    });
    return modelLoader;
  }

  function gallery(product, country) {
    var galleryNode = element('div', 'swishcb-hoop-info__gallery');
    var stage = element('div', 'swishcb-hoop-info__media');
    var thumbs = element('div', 'swishcb-hoop-info__thumbnails');
    thumbs.setAttribute('role', 'group');
    thumbs.setAttribute('aria-label', 'Goalrilla CV72 media');
    var status = element('p', 'swishcb-hoop-info__media-status');
    status.setAttribute('role', 'status');
    var media = (product.media || []).filter(function (item) {
      return ['image', 'video', 'external_video', 'model'].includes(item.media_type);
    });
    if (!media.some(function (item) { return item.media_type === 'model'; })) {
      media.push({ media_type: 'model', sources: [{ url: MODEL, format: 'glb' }], alt: 'Goalrilla CV72 interactive 3D model' });
    }
    var selection = 0;
    function select(item, button, index) {
      var version = ++selection;
      stage.querySelectorAll('video').forEach(function (video) { video.pause(); });
      stage.replaceChildren();
      thumbs.querySelectorAll('button').forEach(function (thumb) { thumb.setAttribute('aria-current', String(thumb === button)); });
      status.textContent = (index + 1) + ' / ' + media.length;
      if (item.media_type === 'image') {
        var zoom = element('button', 'swishcb-hoop-info__zoom');
        zoom.type = 'button';
        zoom.setAttribute('aria-label', 'Zoom Goalrilla CV72 image');
        zoom.setAttribute('aria-pressed', 'false');
        var img = element('img');
        img.src = item.src;
        img.alt = regionalText(item.alt || product.title, country);
        img.width = item.width || 1000;
        img.height = item.height || 1000;
        img.onerror = function () { status.textContent = 'Image unavailable. Please select another image.'; };
        zoom.append(img);
        zoom.addEventListener('click', function () {
          var active = zoom.getAttribute('aria-pressed') !== 'true';
          zoom.setAttribute('aria-pressed', String(active));
          zoom.setAttribute('aria-label', active ? 'Zoom out Goalrilla CV72 image' : 'Zoom Goalrilla CV72 image');
        });
        zoom.addEventListener('pointermove', function (event) {
          var bounds = zoom.getBoundingClientRect();
          img.style.transformOrigin = ((event.clientX - bounds.left) / bounds.width * 100) + '% ' + ((event.clientY - bounds.top) / bounds.height * 100) + '%';
        });
        stage.append(zoom);
      } else if (item.media_type === 'video') {
        var video = element('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        if (item.preview_image) video.poster = item.preview_image.src;
        (item.sources || []).forEach(function (source) {
          var node = element('source'); node.src = source.url; node.type = source.mime_type; video.append(node);
        });
        stage.append(video);
      } else if (item.media_type === 'external_video') {
        var play = element('button', 'swishcb-hoop-info__action', 'Play video');
        play.type = 'button';
        play.addEventListener('click', function () {
          var id = encodeURIComponent(item.external_id || '');
          var url = item.host === 'youtube' ? 'https://www.youtube-nocookie.com/embed/' + id : item.host === 'vimeo' ? 'https://player.vimeo.com/video/' + id : '';
          if (!url) return;
          var frame = element('iframe'); frame.src = url; frame.title = item.alt || 'Goalrilla CV72 video'; frame.allowFullscreen = true;
          stage.replaceChildren(frame);
        });
        stage.append(play);
      } else {
        var source = (item.sources || []).find(function (entry) { return entry.format === 'glb' || /\.glb(?:\?|$)/.test(entry.url || ''); });
        if (!source) { status.textContent = '3D model unavailable.'; return; }
        stage.append(element('p', '', 'Loading 3D view…'));
        loadModelViewer().then(function () {
          if (version !== selection || !stage.isConnected) return;
          var model = element('model-viewer');
          model.setAttribute('src', source.url);
          model.setAttribute('alt', item.alt || 'Goalrilla CV72 interactive 3D model');
          model.setAttribute('camera-controls', '');
          model.setAttribute('camera-orbit', 'auto 90deg auto');
          model.setAttribute('field-of-view', '24deg');
          model.setAttribute('touch-action', 'pan-y');
          model.addEventListener('error', function () { status.textContent = '3D model unavailable. Please select a photo.'; });
          stage.replaceChildren(model);
        }).catch(function () {
          if (version === selection && stage.isConnected) stage.replaceChildren(element('p', '', '3D view could not load. Please select a photo.'));
        });
      }
    }
    media.forEach(function (item, index) {
      var button = element('button', 'swishcb-hoop-info__thumbnail');
      button.type = 'button';
      button.setAttribute('aria-label', item.media_type === 'image' ? 'View Goalrilla CV72 image ' + (index + 1) : item.media_type === 'model' ? 'View Goalrilla CV72 in 3D' : 'View Goalrilla CV72 video ' + (index + 1));
      if (item.media_type === 'image') {
        var thumb = element('img');
        var url = new URL(item.preview_image && item.preview_image.src || item.src, location.href);
        url.searchParams.set('width', '180');
        thumb.src = url.href; thumb.alt = ''; thumb.width = 180; thumb.height = 180; thumb.loading = 'lazy';
        button.append(thumb);
      } else button.textContent = item.media_type === 'model' ? '3D' : '▶ Video';
      button.addEventListener('click', function () { select(item, button, index); });
      thumbs.append(button);
    });
    galleryNode.append(stage, thumbs, status);
    if (media.length) select(media[0], thumbs.firstElementChild, 0);
    return galleryNode;
  }

  function render(product, country) {
    var description = element('div', 'swishcb-hoop-info__specifications');
    description.innerHTML = product.description || '';
    description.querySelectorAll('script, style, iframe, form').forEach(function (node) { node.remove(); });
    var walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) walker.currentNode.textContent = regionalText(walker.currentNode.textContent, country);
    var intro = description.firstElementChild;
    var nodes = [];
    if (intro && intro.tagName === 'P') {
      intro.classList.add('swishcb-hoop-info__description');
      nodes.push(intro);
    }
    nodes.push(gallery(product, country), description);
    content.replaceChildren.apply(content, nodes);
    content.dataset.country = country;
    content.setAttribute('aria-busy', 'false');
    content.scrollTop = 0;
  }

  async function load(url, country) {
    var current = ++generation;
    if (request) request.abort();
    request = new AbortController();
    content.setAttribute('aria-busy', 'true');
    var loading = element('p', '', 'Loading Goalrilla CV72 information…');
    loading.setAttribute('role', 'status');
    content.replaceChildren(loading);
    try {
      var product = products.get(url);
      if (!product) {
        var response = await fetch(url + '.js', { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product unavailable');
        product = await response.json();
        if (product.handle !== HANDLE) throw new Error('Unexpected product');
        products.set(url, product);
      }
      if (current === generation && dialog.open) render(product, country);
    } catch (error) {
      if (current !== generation || error.name === 'AbortError') return;
      content.setAttribute('aria-busy', 'false');
      var message = element('p', '', 'The hoop information could not load. Please try again.');
      message.setAttribute('role', 'alert');
      var retry = element('button', 'swishcb-hoop-info__action', 'Try again');
      retry.type = 'button'; retry.addEventListener('click', function () { load(url, country); });
      var fallback = element('a', 'swishcb-hoop-info__fallback', 'View CV72 product page');
      fallback.href = url; fallback.target = '_blank'; fallback.rel = 'noopener';
      content.replaceChildren(message, retry, fallback);
    }
  }

  function open(link, country) {
    // Preview editors live in same-origin iframes. Use the storefront's modal
    // so it is never clipped by the card or its sticky/scrolling containers.
    if (window.parent !== window) {
      try {
        if (window.parent.SwishCBHoopInfo) { window.parent.SwishCBHoopInfo.open(link, country); return; }
      } catch (_) { /* Fall back to this document if embedding is cross-origin. */ }
    }
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.endsWith('/products/' + HANDLE)) return;
    if (!dialog) makeDialog();
    opener = link;
    if (!dialog.open) {
      dialog.showModal();
      restoreScroll = lockScroll();
    }
    load(url.origin + url.pathname, String(country || window.Shopify && window.Shopify.country || 'LV').toUpperCase());
  }

  window.SwishCBHoopInfo = { open: open };
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-swishcb-hoop-price-label]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var purchase = link.closest('[data-swishcb-hoop-purchase]');
    var checkbox = purchase && purchase.querySelector('[data-swishcb-hoop-purchase-toggle]');
    var select = purchase && purchase.querySelector('[data-swishcb-hoop-purchase-select]');
    if (!checkbox || !checkbox.checked || !select || select.value !== 'CV72') return;
    event.preventDefault();
    event.stopPropagation();
    open(link, purchase.dataset.swishcbHoopPurchaseCountry);
  }, true);
})();
